import { render, staticRenderFns } from "./EmployeesByAge.vue?vue&type=template&id=ebf138fc&scoped=true&"
import script from "./EmployeesByAge.vue?vue&type=script&lang=js&"
export * from "./EmployeesByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf138fc",
  null
  
)

export default component.exports